import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';

import {
  getLoginUrl,
  getLogOutUrl,
  getSignUpUrl,
} from '../../helpers/authUrls';
import { AnchorLink } from '../AnchorLink';
import messages from './AccountMenu.messages';
import {
  FirstLastName,
  Header,
  LoginButton,
  LogOutInfo,
  UserEmail,
  Wrapper,
} from './AccountMenu.styles';
import ListItems from './ListItems';
import USER from './query.graphql';

const AccountMenu = ({ logout, isLoggedIn }) => {
  const { data, loading, error } = useQuery(USER, {
    skip: !isLoggedIn,
    ssr: false,
  });

  if (loading || error) {
    return null;
  }

  if (!isLoggedIn) {
    return (
      <Wrapper data-testid="account">
        <Header>
          <LoginButton
            id="account-menu-login-button"
            data-testid="account-login-button"
            href={getLoginUrl()}
          >
            <FormattedMessage {...messages.login} />
          </LoginButton>
          <FormattedMessage {...messages.signUpInfo} />{' '}
          <AnchorLink
            data-testid="account-sign-up-button"
            href={getSignUpUrl()}
          >
            <FormattedMessage {...messages.signUp} />
          </AnchorLink>
        </Header>
        <ListItems />
      </Wrapper>
    );
  }

  const { firstName, lastName, email } = data.user.customer;

  return (
    <Wrapper data-testid="account">
      <Header>
        <FirstLastName data-testid="account-name">
          {firstName} {lastName}
        </FirstLastName>
        <UserEmail data-testid="account-email">{email}</UserEmail>
      </Header>

      <ListItems />

      <LogOutInfo>
        <FormattedMessage
          {...messages.logoutInfo}
          values={{ name: `${firstName} ${lastName}` }}
        />{' '}
        <AnchorLink
          data-testid="account-logout-button"
          href={getLogOutUrl()}
          onClick={() => logout()}
        >
          <FormattedMessage {...messages.logout} />
        </AnchorLink>
      </LogOutInfo>
    </Wrapper>
  );
};

AccountMenu.propTypes = {
  logout: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
};

export default AccountMenu;
